import React from "react"

// Renders the small amount of Markdown that short Contentful text fields use:
// [links](https://...) and **bold**. Anything else shows as plain text. It
// builds React elements rather than injecting HTML, so a stray tag in an entry
// cannot reach the page.
const TOKEN = /\[([^\]]+)\]\(([^)\s]+)\)|\*\*([^*]+)\*\*/g

const isExternal = href => /^https?:\/\//.test(href)

// Relative paths, anchors, http(s), mailto and tel only. Anything else (for
// example javascript:) shows as plain text.
const isSafeHref = href =>
  /^(\/|#|https?:\/\/|mailto:|tel:)/i.test(href) && !href.startsWith("//")

export const renderInlineMarkdown = text => {
  if (!text) return null
  const parts = []
  let last = 0
  let match
  TOKEN.lastIndex = 0
  while ((match = TOKEN.exec(text))) {
    if (match.index > last) parts.push(text.slice(last, match.index))
    const [, label, href, bold] = match
    if (label && !isSafeHref(href)) {
      parts.push(label)
    } else if (label) {
      parts.push(
        <a
          href={href}
          key={match.index}
          rel={isExternal(href) ? "noopener noreferrer" : undefined}
        >
          {label}
        </a>
      )
    } else {
      parts.push(<strong key={match.index}>{bold}</strong>)
    }
    last = TOKEN.lastIndex
  }
  if (last < text.length) parts.push(text.slice(last))
  return parts
}

// Blank lines start a new paragraph.
export const renderMarkdownParagraphs = text =>
  text
    ? text
        .split(/\n\s*\n/)
        .map(p => p.trim())
        .filter(Boolean)
        .map((p, i) => <p key={i}>{renderInlineMarkdown(p)}</p>)
    : null
